/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * List of ineligibility reasons for disruption rebooking
 */
export enum FinnairDisruptionRebookingIneligibilityReason {
  NOT_ELIGIBLE_EMAIL_MISSING = 'NOT_ELIGIBLE_EMAIL_MISSING',
  AMADEUS_REASON = 'AMADEUS_REASON',
  AURINKOMATKAT_TICKETS = 'AURINKOMATKAT_TICKETS',
  COMMERCIAL_COOPERATION_TICKETS = 'COMMERCIAL_COOPERATION_TICKETS',
  ID_TICKETS = 'ID_TICKETS',
  LEISURE_AND_STAFF = 'LEISURE_AND_STAFF',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NOT_ELIGIBLE_SSR = 'NOT_ELIGIBLE_SSR',
  MORE_THAN_TWO_BOUNDS = 'MORE_THAN_TWO_BOUNDS'
}

